import {
    getModule,
    Module,
    VuexModule,
    Mutation,
  } from "vuex-module-decorators";
  import { store } from "@/store/store";
  
  @Module({
    namespaced: true,
    name: "OcultarCamposModule",
    store,
    dynamic: true,
  })
  class OcultarCamposModule extends VuexModule {
    public mostrar_campos_coste: boolean = true;
    public Ocultar_tarjeta_efectivo: boolean = true;
    @Mutation
    public Mostrar() {
      this.mostrar_campos_coste = true;
    }
    @Mutation
    public NoMostrar() {
      this.mostrar_campos_coste = false;
    }
    @Mutation
    public MostrarTarjetaEfectivo() {
      this.Ocultar_tarjeta_efectivo = false;
    }
    @Mutation
    public NoMostrarTarjetaEfectivo() {
      this.Ocultar_tarjeta_efectivo = true;
    }
  }
  export default getModule(OcultarCamposModule);
  